import type { UUID } from '@cobliteam/common-types';

export enum ChatType {
  HUMAN = 'HUMAN',
  AI = 'AI',
}

export enum FeedbackOption {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT',
  INCOMPLETE = 'INCOMPLETE',
}

export interface PromptRequest {
  prompt: string;
}

export interface ChatHistory {
  id: number;
  type: ChatType;
  content: string;
  createdAt: string;
  feedback?: FeedbackOption;
}

export interface ChatSession {
  id: UUID;
  createdAt: string;
  chatHistory: ChatHistory[];
}
